module.exports = __webpack_public_path__ + "static/media/Vamp2.1bfecc14.png";